import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M25.052.5v8.938H11.558l-.483 4.687c.78-.11 1.575-.179 2.407-.179 3.584 0 6.96 1.125 9.447 3.288 2.496 2.17 4.067 5.362 4.067 9.416 0 8.57-6.574 14.702-15.728 14.702-4.82 0-8.33-1.664-10.572-3.457l-.192-.154.004-.246.162-9.611.032-1.93.91 1.702c.587 1.1 1.807 2.228 3.399 3.082 1.584.85 3.489 1.406 5.394 1.406 3.85 0 6.303-2.278 6.303-5.224 0-1.594-.679-2.863-1.877-3.75-1.212-.896-2.988-1.42-5.183-1.42-2.714 0-5.534.837-7.663 2.24l-.859.566.086-1.026L3.102.958 3.14.5h21.912Z"
        />
    </Svg>
);
export { SvgComponent as FiveIcon };
